export default __webpack_public_path__ + "static/bg-b82e273c325a5fbc387118bb28b0b64d.svg";